'use client'

type FlutterWebViewWindow = Window & {
  flutter_inappwebview?: {
    callHandler: (handlerName: string, payload: string) => unknown
  }
}

export const useDownload = () => {
  const download = (downloadUrl: string) => {
    const flutterWebView = (window as FlutterWebViewWindow).flutter_inappwebview
    flutterWebView?.callHandler(
      'WebViewConnect',
      JSON.stringify({
        action: 'intent',
        action_value: { url: downloadUrl },
      })
    )
  }

  return { download }
}
